import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CountrySwitchModalComponent} from './country-switch-modal.component';
import {I18nModule, UrlModule} from '@spartacus/core';
import {RouterModule} from '@angular/router';
import {CountrySwitchContentComponent} from './country-switch-content/country-switch-content.component';


@NgModule({
  declarations: [
    CountrySwitchModalComponent,
    CountrySwitchContentComponent
  ],
  exports: [
    CountrySwitchModalComponent
  ],
  imports: [
    CommonModule,
    I18nModule,
    RouterModule,
    UrlModule
  ]
})
export class CountrySwitchModalModule {
}
